module.exports = __webpack_public_path__ + "static/media/tunic.d746a48e.png";